module.exports = __webpack_public_path__ + "static/img/logo-if-mp.68bcf8b9.svg";